export default "__VITE_ASSET__BczXClnm__"